import { CeilingFanLightIcon } from './CeilingFanLightIcon';

/**
 * author: nilsfast
 * id 326FF6B4-E497-4C9C-8EA5-D3FEACF0B2AE
 * name ceiling-fan-light
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-fan-light.svg
 * tags
 * - Home Automation 
 */
export const CeilingFanOnIcon = CeilingFanLightIcon;
export default CeilingFanOnIcon